import React from 'react';
import {Card, Row, Col} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import GroupRootButtonCreate from '../components/GroupRootButtonCreate';
import GroupTree from '../components/GroupTree';

import {fetchGroups, postGroup, updateGroup, deleteGroup} from '../actions/group'
import {UUID_NULL} from '../constants/defaultValues'

class Groups extends React.Component {
  state = {
    group: {
      ID: UUID_NULL,
      ParentID: UUID_NULL,
      Name: ""
    },
    parent: {
      ID: UUID_NULL,
      ParentID: UUID_NULL,
      Name: ""
    }
  };

  componentWillMount() {
    this.props.dispatch(fetchGroups())
  }

  handleCreate = (group) => {
    const {currentSystem} = this.props
    const newGroup = {
      ...group,
      SystemID: currentSystem.ID,
      HardwareType: currentSystem.HardwareType
    }
    this.props.dispatch(postGroup(newGroup))
  }

  handleUpdate = (group) => {
    this.props.dispatch(updateGroup(group))
  }

  handleDelete = (group) => {
    this.props.dispatch(deleteGroup(group))
  }

  render() {
    const {group} = this.state
    const {groups, treeGroups} = this.props
    return (<Card title="Quản lí địa bàn" bordered={false} extra={<GroupRootButtonCreate group = {
        group
      }
      groups = {
        groups
      }
      onCreate = {
        this.handleCreate
      }
      type = "primary" text = "Thêm mới" ghost = {
        true
      } />}>
      <Row>
        <Col xs={{
            span: 24
          }} sm={{
            span: 9
          }} md={{
            span: 7
          }} lg={{
            span: 6
          }} xl={{
            span: 5
          }}>
          <GroupTree treeGroups={treeGroups} groups={groups} onSelect={this.handleSelect} onCreate={this.handleCreate} onUpdate={this.handleUpdate} onDelete={this.handleDelete}/>
        </Col>
      </Row>
    </Card>);
  }
}
Groups.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  groups: PropTypes.array,
  treeGroups: PropTypes.array,
  fetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {currentSystem: state.system.currentSystem, groups: state.group.groups, treeGroups: state.group.treeGroups, fetching: state.group.fetching, error: state.group.error}
}

export default connect(mapStateToProps)(Groups)



// WEBPACK FOOTER //
// ./src/pages/Groups.js